export const ORG_TAGS_QUERY_KEY = 'organisationTags';
export const ORG_QUERY_KEY = 'organisation';
export const ORGS_QUERY_KEY = 'organisations';
